import {
  Group,
  Stack,
  Title,
  Text,
  Divider,
  GroupProps,
  TitleOrder,
} from "@mantine/core"
import { ReactNode } from "react"

export type SectionHeaderProps = {
  title?: string
  subtitle?: string
  mainCta?: ReactNode
  divider?: boolean
  justify?: "start" | "end" | "center" | "space-between" | "space-around"
  order?: TitleOrder
} & GroupProps

export const SectionHeader = ({
  title,
  mainCta,
  subtitle,
  divider,
  justify = "space-between",
  order = 3,
  ...props
}: SectionHeaderProps) => {
  return (
    <Group justify={justify} pb="var(--tfg-layout-padding-y)" {...props}>
      <Stack gap="xs">
        <Title order={order}>{title}</Title>
        {subtitle && <Text>{subtitle}</Text>}
      </Stack>
      {mainCta}
      {divider && <Divider w="100%" />}
    </Group>
  )
}
